import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getPrefixes, updatePrefix, type PrefixQuery } from '../api/prefixApi'
import type { PrefixUpdate } from '../types'

const KEY = 'minutes-prefixes'

/**
 * Ön Ek Tanımları sunucu-durumu (056): sayfalı liste + ad/ön ek güncelleme.
 *
 * **Dil `queryKey`'in parçası DEĞİLDİR:** tabloda `_TR`/`_EN` kolonu yoktur, `name`/`prefix` tek
 * dillidir ve `Accept-Language` yanıtı etkilemez → TR↔EN geçişinde yeniden çekmek gereksizdir
 * (045'ten bilinçli fark: orada `moduleName` sunucuda çözülüyordu).
 *
 * **`keepPreviousData`:** sunucu-taraflı sayfalamada sayfa değişirken `isLoading` yeniden `true` olur;
 * paylaşılan `DataTable`'ın iskelet dalı paginator'ı render etmediği için sayfalama kontrolü kaybolup
 * tablo titrer. Önceki veri korunarak bu önlenir (repodaki diğer sunucu-sayfalı listelerle aynı kalıp).
 *
 * **`handledCodes: ['DUPLICATE_CODE']`:** yinelenen ön ek hatası **alan altında** gösterilir; merkezî
 * hata yönetimi (019) bu kod için toast basmaz.
 */
export function usePrefixes(query: PrefixQuery) {
  const qc = useQueryClient()

  const list = useQuery({
    queryKey: [KEY, query.page, query.size],
    queryFn: () => getPrefixes(query),
    placeholderData: keepPreviousData,
  })

  const update = useMutation({
    mutationFn: ({ id, body }: { id: number; body: PrefixUpdate }) => updatePrefix(id, body),
    // Kaydetme sonrası listeyi tazele → ad/ön ek sütunları güncel (SC-002).
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    meta: { handledCodes: ['DUPLICATE_CODE'] },
  })

  return { list, update }
}
